import { z } from 'zod';

export const CoreNotifyCommunicationAttemptTwilioStatusTypeSchema = z.enum(['Accepted','Scheduled','Queued','Canceled','Sent','Failed','Delivered','Undelivered','Receiving','Received','Read','PartiallyDelivered','Sending','Busy','Completed','InProgress','NoAnswer','Ringing','Initiated']);

export type CoreNotifyCommunicationAttemptTwilioStatusTypeType = `${z.infer<typeof CoreNotifyCommunicationAttemptTwilioStatusTypeSchema>}`

export default CoreNotifyCommunicationAttemptTwilioStatusTypeSchema;
